import { type UseQueryResult, useQuery } from 'react-query';
import { PsuAwardService, RsuAwardService } from '@wealthlane/api-services/wealthlane-award-service';

const useGetPsuAwardParticipantStatusOptions = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>
): UseQueryResult<
  | Array<{
      label: string;
      value: string | number;
    }>
  | undefined,
  unknown
> => {
  const psuAwardParticipantStatus = useQuery(
    ['getPsuAwardParticipantStatus'],
    async () => {
      return await handleRequest(PsuAwardService.getApiAwardApiAppPSUAwardPSUAwardStatuses());
    },
    {
      select: (data) => {
        const options = data?.map((item) => {
          return {
            label: item.name ?? '',
            value: item.id ?? '',
          };
        });
        const sortOptions = options?.concat({ label: 'All', value: 0 }).sort(function (a, b) {
          return a.label.localeCompare(b.label);
        });
        return sortOptions;
      },
    }
  );

  return psuAwardParticipantStatus;
};

export default useGetPsuAwardParticipantStatusOptions;
